module.exports = function (app, mod, invite) {
  var _invite$game_mod, _invite$game_mod$retu, _invite$tentative;
  var invite_class = invite.target && invite.players[invite.target - 1] == mod.publicKey ? ' my-turn' : '';
  var invite_img = ((_invite$game_mod = invite.game_mod) === null || _invite$game_mod === void 0 || (_invite$game_mod$retu = _invite$game_mod.returnBanner) === null || _invite$game_mod$retu === void 0 ? void 0 : _invite$game_mod$retu.call(_invite$game_mod)) || "/".concat(String(invite.game_slug || '').replace(/[^a-zA-Z0-9_-]/g, ''), "/img/arcade/arcade-banner-background.png");
  var badge = '';
  if (invite_class) {
    badge = "<div class=\"badge\">your turn</div>";
  }
  if (invite.winner) {
    if (invite.winner.includes(mod.publicKey)) {
      badge = "<div class=\"badge\">you won</div>";
    } else {
      badge = "<div class=\"badge\">you lost</div>";
    }
  }
  var risk_mode_html = '';
  if (invite.risk_mode) {
    var risk_label = app.browser.escapeHTML(invite.risk_mode);
    var risk_lines = risk_label.split(/\s+/).join('<br>');
    risk_mode_html = "<div class=\"risk-mode-ribbon\" aria-label=\"".concat(risk_label, "\"><span class=\"risk-mode-ribbon__text\">").concat(risk_lines, "</span></div>");
  }
  var details_line = invite.economic_line ? invite.economic_line : String(invite.game_type || '').toUpperCase();
  var html = "\n    <div class=\"invite arcade-invite".concat(invite_class, "\" id=\"arcade-invite-").concat(invite.game_id, "\"\n         style=\"background-image: url('").concat(invite_img, "');\">\n      ").concat(risk_mode_html, "\n      <div class=\"invite-title\">\n        <div class=\"header\">\n          <div class=\"title\">").concat(app.browser.escapeHTML(invite.game_name), "</div>\n          <div class=\"details\">").concat(app.browser.escapeHTML(details_line), "</div>\n        </div>\n      </div>\n      <div class=\"actions\">\n        ").concat(badge, "\n        <div class=\"players\">\n  ");
  for (var i = 0; i < invite.players.length; i++) {
    html += "\n          <div class=\"player\">\n            <img class=\"saito-identicon\" id=\"".concat(invite.players[i], "\"\n                 src=\"").concat(app.keychain.returnIdenticon(invite.players[i]), "\">\n          </div>");
  }
  var tentative_join = ((_invite$tentative = invite.tentative) === null || _invite$tentative === void 0 ? void 0 : _invite$tentative.join) || [];
  for (var _i = 0; _i < tentative_join.length; _i++) {
    var pkey = tentative_join[_i];
    if (invite.players.includes(pkey)) {
      continue;
    }
    html += "\n          <div class=\"pending\">\n            <img class=\"saito-module-identicon saito-identicon\" id=\"".concat(pkey, "\"\n                 src=\"").concat(app.keychain.returnIdenticon(pkey), "\">\n          </div>");
  }
  for (var _i2 = 0; _i2 < invite.desired_opponent_publickeys.length; _i2++) {
    html += "\n          <div class=\"requested\">\n            <img class=\"saito-identicon\" id=\"".concat(invite.desired_opponent_publickeys[_i2], "\"\n                 src=\"").concat(app.keychain.returnIdenticon(invite.desired_opponent_publickeys[_i2]), "\">\n          </div>\n      ");
  }
  for (var _i3 = 0; _i3 < invite.empty_slots; _i3++) {
    html += "<div class=\"slot\"></div>";
  }
  html += "\n        </div>\n      </div>\n    </div>";
  return html;
};